module.exports = __webpack_public_path__ + "media/images/front/brands/atelier/atelier_3-d25800bdc366d2821608b6b1324d1cad.webp";